<div class="loading">
  <app-loading-indicator-base class="w-100" [loadingIndicatorStyle]="eLoadingIndicatorStyle">
  </app-loading-indicator-base>
</div>